<template>
  <b-tab title="Prioridades" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE PRIORIDADES DE ENTREGA :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterPrioridades(filtro)" :fields="fields.prioridade">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="itens(data.item)" v-b-tooltip.hover title="Itens">
              <b-icon icon="diagram3" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="atv-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="atv-sol-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Solicitante"
              v-model="filtro.solicitante"
            />
            <b-form-input
              id="atv-cliente-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Cliente"
              v-model="filtro.cliente"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-form-select class="ml-2" size="sm" v-model="filtro.status" :options="options" />
            <b-button size="sm" class="m-1 ml-3" variant="light">
              {{ quantidade + " prioridades" }}
            </b-button>
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <prioridade-modal ref="editorPrioridade" />
      <confirm-modal ref="confirmDelPrioridade" :descricao="'Deseja realmente remover a prioridade ?'" @executar="executar()" />
      <itens-list-modal ref="prioridadeItensList" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { usePrioridadeStore } from "@/stores/PrioridadeStore";
import Prioridade from "@/models/Prioridade";
import TableFields from "@/tools/TableFields";
import PrioridadeModal from "@/components/modals/armazem/PrioridadeModal";
import ItensListModal from "@/components/modals/armazem/ItensListModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
import Notificacao from "@/models/Notificacao";

export default {
  name: "PrioridadeTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        descricao: "",
        solicitante: "",
        cliente: "",
        status: "",
      },
      prioridade: new Prioridade(0, "Nova Prioridade", "", "", "", new Date(), "não atendida"),
      options: [
        { value: "", text: "todos" },
        { value: "não atendida", text: "não atendida" },
        { value: "parcialmente atendida", text: "parcialmente atendida" },
        { value: "atendida", text: "atendida" },
      ],
    };
  },

  components: {
    "prioridade-modal": PrioridadeModal,
    "confirm-modal": ConfirmModal,
    "itens-list-modal": ItensListModal,
  },

  computed: {
    quantidade() {
      return this.getFilterPrioridades(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.prioridade = new Prioridade(0, "Nova Prioridade", "", "", "", new Date(), "não atendida");
      this.$refs.editorPrioridade.call(this.prioridade);
    },

    editar(prioridade) {
      this.$refs.editorPrioridade.call(prioridade);
    },

    itens(prioridade) {
      this.$refs.prioridadeItensList.call(prioridade);
    },

    deletar(prioridade) {
      this.prioridade.update(prioridade);
      this.$refs.confirmDelPrioridade.call();
    },

    executar() {
      this.prioridadeStore.LISTAR_PRIORIDADES(this.prioridade.id).then(() => {
        if (this.getItens.length === 0) {
          this.prioridadeStore.REMOVER_PRIORIDADE(this.prioridade.id);
        } else {
          this.store.NOTIFICAR(new Notificacao("Existem itens não atendidos na prioridade!", "Não Executado!", "danger"));
        }
      });
    },
  },

  setup() {
    const store = useSgcqStore();
    const prioridadeStore = usePrioridadeStore();
    const { getItens } = storeToRefs(prioridadeStore);
    const { getFilterPrioridades } = storeToRefs(prioridadeStore);

    return {
      store,
      prioridadeStore,
      getFilterPrioridades,
      getItens,
    };
  },
};
</script>

<style lang="scss" scoped>
#atv-desc-filter {
  width: 18rem;
}
#atv-cliente-filter {
  width: 14rem;
}
#atv-solicitante-filter {
  width: 14rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
